<template>
  <div class="demo-alignment">
    <vs-button @click="popupActive=true" class="mr-3 mb-2">Open background popup</vs-button>

    <vs-popup
      background-color="rgba(255,255,255,.6)"
      :background-color-popup="colorx"
      class
      title="Background"
      :active.sync="popupActive"
    >
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
    </vs-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      colorx: "#def1d1",
      popupActive: false,
    }
  }
}
</script>
<style lang=""></style>